/**
 * The project types every account starts with: onboarding offers them, and
 * Ask MDT matches "a remodel project" against them (MYD-614).
 *
 * **Must match `DEFAULT_PROJECT_TYPES` in `backend/utilities/projectTypes.js`.**
 * Duplicated rather than imported, because this is app code compiled by CRA
 * and a server module must not reach the browser bundle.
 * `projectTypes.parity.test.ts` imports both and fails if they ever disagree.
 */
export const DEFAULT_PROJECT_TYPES: readonly string[] = Object.freeze([
	'Site Selection',
	'Lease Negotiation',
	'Lease Renewal',
	'New Construction',
	'Store Opening',
	'Remodel',
	'Relocation',
	'Other',
])
